// REACT
import React, { useRef, useContext } from 'react'

// ESTILOS
import Styles from './ShowBook.module.css'

// ASSETS
import virgin from 'Assets/General/v1.jpg'
import virgin2 from 'Assets/General/v2.jpg'
import CloseButton from 'Components/CloseButton/CloseButton'
import MainContext from 'Context/MainContext'

// PROPIEDADES
interface ShowBookProps {
	style: object
	name: string
	title?: string
	title2?: string
	text?: string
	text2?: string
	img?: any
	img2?: any
	type?: 'history' | 'sosten' | 'covid'
}

const ShowBook: React.FC<ShowBookProps> = (props: ShowBookProps) => {
	// CONTEXTO
	const { history_pol, policies_and_sustainability, covid } = useContext(MainContext).lang

	// REFERENCIAS
	const port: React.RefObject<HTMLDivElement> = useRef(null)
	let status: boolean = false

	// MOSTRAR/OCULTAR DIALOGO
	const showDialog = (text: string) => {
		if (port.current) {
			if (text === 'open' && !status) {
				port.current.style.display = 'flex'
				status = true
			} else if (text === 'close' && status) {
				port.current.style.display = 'none'
				status = false
			}
		}
	}

	// TOGGLE DIALOG
	const openDialog = () => showDialog('open')
	const closeDialog = () => showDialog('close')

	// DETECT TYPE
	const computeType = () => {
		if (props.type === 'history') {
			return (
				<div className={Styles.scroller}>
					<CloseButton
						style={{
							backgroundColor: 'goldenrod',
							borderColor: 'goldenrod',
							width: '50px',
							minHeight: '50px',
							fontSize: '25px',
						}}
						action={closeDialog}
					/>
					<div className={Styles.contenido}>
						<h1>{history_pol.title}</h1>
						<p>{history_pol.text_1}</p>
						<br />
						<p>{history_pol.text_2}</p>
						<br />
						<p>{history_pol.text_3}</p>
						<div className={Styles.viewImg}>
							<img src={virgin} alt='virgin' />
							<img src={virgin2} alt='virgin' />
						</div>
					</div>
				</div>
			)
		} else if (props.type === 'sosten') {
			return (
				<div className={Styles.scroller}>
					<CloseButton
						style={{
							backgroundColor: 'goldenrod',
							borderColor: 'goldenrod',
							width: '50px',
							minHeight: '50px',
							fontSize: '25px',
						}}
						action={closeDialog}
					/>
					<div className={Styles.contenido}>
						<h1>{policies_and_sustainability.title_1}</h1>
						<p>{policies_and_sustainability.text_1}</p>
						<p>{policies_and_sustainability.text_2}</p>
						<p>{policies_and_sustainability.text_3}</p>
						<br />
						<h1>{policies_and_sustainability.title_2}</h1>
						<p>{policies_and_sustainability.text_4}</p>
						<p>{policies_and_sustainability.text_5}</p>
						<p>{policies_and_sustainability.text_6}</p>
						<p>{policies_and_sustainability.text_7}</p>
					</div>
				</div>
			)
		} else if (props.type === 'covid') {
			return (
				<div className={Styles.scrollerCovid}>
					<CloseButton
						style={{
							backgroundColor: 'goldenrod',
							borderColor: 'goldenrod',
							width: '50px',
							minHeight: '50px',
							fontSize: '25px',
						}}
						action={closeDialog}
					/>
					<div className={Styles.contenidoCovid}>
						<h1>{covid.title_1}</h1>
						<p>{covid.text_1}</p>
						<h1>{covid.title_2}</h1>
						<p>{covid.text_2}</p>
						<p>{covid.text_3}</p>
						<p>{covid.text_4}</p>
						<p>{covid.text_5}</p>
						<p>{covid.text_6}</p>
						<p>{covid.text_7}</p>
						<p>{covid.text_8}</p>
						<p>{covid.text_9}</p>
						<p>{covid.text_10}</p>
						<p>{covid.text_11}</p>
						<p>{covid.text_12}</p>
						<h1>{covid.title_3}</h1>
						<p>{covid.text_13}</p>
						<p>{covid.text_14}</p>
						<p>{covid.text_15}</p>
						<p>{covid.text_16}</p>
						<p>{covid.text_17}</p>
						<h1>{covid.title_4}</h1>
						<p>{covid.text_18}</p>
						<p>{covid.text_19}</p>
						<h1>{covid.title_5}</h1>
						<p>{covid.text_20}</p>
						<p>{covid.text_21}</p>
					</div>
				</div>
			)
		} else {
			return (
				<div className={Styles.scroller}>
					<CloseButton
						style={{
							backgroundColor: 'goldenrod',
							borderColor: 'goldenrod',
							width: '50px',
							minHeight: '50px',
							fontSize: '25px',
						}}
						action={closeDialog}
					/>
					<div className={Styles.contenido}>
						<h1>{props.title}</h1>
						<p>{props.text}</p>
						{props.img ? (
							<div className={Styles.viewImg}>
								<img src={props.img} alt='virgin' />
								<img src={props.img2} alt='virgin' />
							</div>
						) : (
							''
						)}
						<h1>{props.title2}</h1>
						<p>{props.text2}</p>
					</div>
				</div>
			)
		}
	}

	return (
		<>
			<div style={props.style} onClick={openDialog}>
				{props.name}
			</div>
			<div className={Styles.container} ref={port}>
				{computeType()}
			</div>
		</>
	)
}

export default ShowBook
